 export enum ModePlanningEquipeEnum {
Regroupement = 0,
Tous = 1,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/ModePlanningEquipeEnum.ts